export const GET_PAYMENT_TOKEN = 'get-payment-token';
const getPaymentToken = () => ({ type: GET_PAYMENT_TOKEN });
export default getPaymentToken;
